import axios from "axios";
import _ from "lodash";
import store from '../index.js.erb'
import CommissionDormService from '../../../components/application/statement_hostel/Services/Api/Commission/Dorm'
import PichersDormService from '../../../components/application/statement_hostel/Services/Api/Pichers/Dorm'
import CommissionInteractionStatementsServices
    from "../../../components/application/statement_hostel/Services/Api/Commission/InteractionStatements";

const PlacesInDormitories = {
    namespaced: true,
    state: {
        hostels: [],
        distribution_places: [],
        selected_dorm_faculty: {
            name_faculty: null,
            places_faculties: []
        },
        set_error: [],

        selection_places: [],
        items: [],
        current_hostels: [],

        //////CardListStatement///////
        selected_place: {
            dormitory: '',
            section: '',
            room: '',
        },
        items_list: [],
        statuses_campus_places: [],
        statuses_faculties_places: [],
        show_faculty_places: {},
        free_places: [],
        places_dorm: {},
        places_for_select: {}

    },
    getters: {

    },
    mutations: {
        setStructHostel(state, response){
            state.hostels = response
        },
        setNameFaculty(state, name_faculty){
            state.selected_dorm_faculty.name_faculty = name_faculty
        },
        setPlaces(state, places_faculties){
            state.selected_dorm_faculty.places_faculties = places_faculties
        },
        setObjectPlacesDormFac(state, distribution_places){
            state.distribution_places = distribution_places
        },
        setPlacesDorm(state, places_dorm){
            state.places_dorm = places_dorm
        },

        delStatement(state, item_statements){
            let index = state.list_statements.findIndex(state => state.id === item_statements.id)
            state.list_statements[index].dean_ex_work_confirm = 1
            state.list_statements[index].result_place = ''
        },
        setDormitory(state, dormitory){
            state.selected_place.dormitory = dormitory
            state.selected_place.section = ''
            state.selected_place.room = ''
        },
        setSection(state, section){
            state.selected_place.section = section
            state.selected_place.room = ''
        },
        setRoom(state, room){
            state.selected_place.room = room
        },
        setItemsList(state, items_list){
            state.items_list = items_list
        },
        setError(state, response){
            state.set_error = response
        },
        setItems(state, items){
            state.items = items
        },
        placesHostels(state, hostels){
            if (hostels === undefined || hostels === '' || hostels === null) state.current_hostels = []
            let ms_hostel = []
            hostels.forEach((element) => {
                if(true) ms_hostel.push(element)
            })
            state.current_hostels = ms_hostel
        },
        setStatusCampusPlaces(state, statuses_campus_places){
            state.statuses_campus_places = statuses_campus_places
        },
        setStatusFacultiesPlaces(state, statuses_faculties_places){
            state.statuses_faculties_places = statuses_faculties_places
        },
        setShowFacultyPlaces(state, show_faculty_places){
            state.show_faculty_places = show_faculty_places
        },
        setFreePlaces(state, free_places){
            state.free_places = free_places
        },
        setPlacesForSelect(state, places_for_select){
            state.places_for_select = places_for_select
        }


    },
    actions: {
        async CreateDormFac({state, commit, dispatch}, selected_place){
            await axios({
                method: 'post',
                url: '/statement_hostel/distribution/campus_and_faculties',
                data: selected_place
            }).then((response) => {
                commit('setError', response.data)
            }).catch((error) => {
                return error
            }).finally(()=>{
                dispatch('GetStatusCampusPlaces')
                dispatch('GetStatusFacultiesPlaces')
                dispatch('GetFacultyPlaces', selected_place.department_id)
            })
        },
        async UpdateDormFac({state, commit, dispatch}, selected_place){
            await axios({
                method: 'put',
                url: '/statement_hostel/distribution/campus_and_faculties/:id',
                data: selected_place
            }).then((response) => {
                commit('setError', response.data)
            }).catch((error) => {
                return error
            }).finally(()=>{
                dispatch('GetStatusCampusPlaces')
                dispatch('GetStatusFacultiesPlaces')
                dispatch('GetFacultyPlaces', selected_place.department_id)
            })
        },
        async GetObjectPlacesDormFac({commit}, department_id){
            const response = await CommissionDormService.show(department_id)

            if (response.data.hasOwnProperty('errors')){
                console.log("Error: " + response.data.errors)
            } else commit('setObjectPlacesDormFac', response.data)
        },
        async GetPlacesForDepartment({commit}, department_id){
            const response = await PichersDormService.places_for_department({department_id: department_id})

            if (response.data.hasOwnProperty('errors')){
                console.log("Error: " + response.data.errors)
            } else commit('setObjectPlacesDormFac', response.data)
        },
        async GetStatusCampusPlaces({state, commit}){
            await axios({
                method: 'get',
                url: '/statement_hostel/distribution/campus_and_faculties/status_places',
            }).then((response) => {
                commit('setStatusCampusPlaces', response.data)
            }).catch((error) => {
                return error
            })
        },
        async GetStatusFacultiesPlaces({state, commit}){
            await axios({
                method: 'get',
                url: '/statement_hostel/distribution/campus_and_faculties/status_faculties_places',
            }).then((response) => {
                commit('setStatusFacultiesPlaces', response.data)
            }).catch((error) => {
                return error
            })
        },
        async GetFacultyPlaces({state, commit}, department_id){
            await axios({
                method: 'get',
                url: `/statement_hostel/distribution/campus_and_faculties/${department_id}`,
            }).then((response) => {
                commit('setShowFacultyPlaces', response.data)
            }).catch((error) => {
                return error
            })
        },
        async DestroyDormFaculty({state, commit, dispatch}, selected_place){
            await axios({
                method: 'delete',
                url: '/statement_hostel/distribution/campus_and_faculties/:id',
                params: selected_place
            }).then((response) => {
            }).catch((error) => {
                return error
            }).finally(()=>{
                dispatch('GetStatusCampusPlaces')
                dispatch('GetStatusFacultiesPlaces')
                dispatch('GetFacultyPlaces', selected_place.department_id)
            })
        },
        async UpdateRoom({state, commit, dispatch}, selected_place){
            await axios({
                method: 'put',
                url: '/statement_hostel/distribution/campus_and_faculties/update_room',
                params: selected_place
            }).then((response) => {
            }).catch((error) => {
                return error
            }).finally(()=>{
                dispatch('GetStatusCampusPlaces')
                dispatch('GetStatusFacultiesPlaces')
                dispatch('GetFacultyPlaces', selected_place.department_id)
            })
        },
        async GetFreePlaces({state, commit}){
            await axios({
                method: 'get',
                url: '/statement_hostel/distribution/campus_and_faculties/get_free_place'
            }).then((response) => {
                commit('setFreePlaces', response.data)
            }).catch((error) => {
                return error
            })
        },

        async GetPlacesForSelect({state, commit}, department_id){
            const response = await CommissionDormService.get_places_for_select({department_id: department_id})
            commit('setPlacesForSelect', response.data)
        },


    }

}

export default PlacesInDormitories